<template>
  <a :href="url">
    <div class="card">
  <el-card :body-style="{ padding: '0px' }">
    <img
        :src="coverUrl"
        class="cover"

    />
    <div style="padding: 14px">
      <h2 class="title">{{title}}</h2>
      <span class="intro">{{intro}}</span>
    </div>
  </el-card>
    </div>
  </a>
</template>

<script>
export default {
  name: "fabric_1",
  data(){
    return{
      title: "一文上手当前热门区块链！ Hyperledger Fabric 区块链实践教学",
      intro: "至少部署三个节点构建完成FABRIC区块链, 并通过GO语言开发，实现自定义的数据提交到链，并能查询交易的数据",
      url: "posts/fabric_1.html",
      coverUrl: "img/fabric_image.png"
    }
  },
  methods:{

  }
}
</script>

<style scoped>
a{
  margin-top: 5%;
  display: block;
}
.card :hover {
  overflow: visible;
  transform: scale(1.1);
  transition: all 0.6s;
}
img{
  width: 100%;

}
.cover{

}
.title{
  color: #303133;
  font-size: small;
}
.intro{
  color: #909399;
  margin-left: 3%;
  font-size: smaller;
}
.el-card{
  height:300px;
  width: 250px;
}
</style>